import React, { Component } from 'react'
import { splitEvery, isNil } from 'ramda'
import moment from 'moment'

import { Div, H6 } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'

import './CardStyles.css'

class DetailCard extends Component {
  parseField(propertyValue, propertyMetadata) {
    const dateFormatString = 'MM/DD/YYYY'
    const dateTimeFormatString = 'MM/DD/YYYY h:mma'

    switch (propertyMetadata.type) {
      case 'DATE':
        return moment(Number(propertyValue) || propertyValue).format(dateFormatString);
      case 'DATETIME':
        return moment(propertyValue).format(dateTimeFormatString)
      default:
        return String(propertyValue)
    }
  }

  determineDisplay(field) {
    const { contact, rawProperties } = this.props

    const propertyValue = !isNil(contact[field]) ? contact[field] : contact.attributes[field]
    const propertyMetadata = rawProperties.filter(property => property.name === field)[0]

    if (!isNil(propertyValue)) return (
      <Div className="contact-details--attribute-truncated">
        {this.parseField(propertyValue, propertyMetadata)}
      </Div>
    )
    else return (
      <span className="needs-information">
        <Div className="contact-details--attribute-truncated">
          add {propertyMetadata.displayName}
        </Div>
      </span>
    )
  }

  render() {
    const { fields, maxLength, iconName, title, iconWidth, rawProperties, onAddData, contact} = this.props
    const chunkedFields = splitEvery(maxLength, fields)

    return (
      <Div className="contact-details--attributes-card">
        <Div className="contact-details--attributes-card-header">
          <Div className="contact-details--attributes-card-header-icon">
            <Icon name={iconName} width={iconWidth} />
          </Div>
          <Div className="contact-details--attributes-card-header-text">
            <H6>{title}</H6>
          </Div>
        </Div>
        {chunkedFields.map((fieldGroup, i) => {
          return (
            <Div className="contact-details--attributes-card-row" key={`contact-detail-field-group${i}`}>
              {
                fieldGroup.map((field, s) => {
                  return (
                    <Div className="contact-details--attributes-card-field" key={`contact-detail-field${s}`}>
                      <span className="field-key">
                        <Div className="contact-details--attribute-truncated">
                          {rawProperties.filter(property => property.name === field)[0].displayName}
                        </Div>
                      </span>
                      <span className="field-value" onClick={() => onAddData(rawProperties.filter(property => property.name === field)[0], contact)}>
                          {this.determineDisplay(field)}
                      </span>
                    </Div>
                  )
                })
              }
            </Div>
          )
        })}
      </Div>
    )
  }
}

export default DetailCard
